import { NavLink, Route, Routes } from "react-router-dom";
import { DownloadPage } from "./pages/DownloadPage";
import { FeaturesPage } from "./pages/FeaturesPage";
import { HomePage } from "./pages/HomePage";
import { LegalPage } from "./pages/LegalPage";

export function App() {
  return (
    <div className="shell">
      <header className="nav">
        <NavLink to="/" className="brand">
          PVPInsight
        </NavLink>
        <nav className="nav-links" aria-label="Primary">
          <NavLink to="/" end>
            Home
          </NavLink>
          <NavLink to="/features">Features</NavLink>
          <NavLink to="/download">Download</NavLink>
          <NavLink to="/privacy">Privacy</NavLink>
          <NavLink to="/terms">Terms</NavLink>
        </nav>
      </header>
      <main className="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
        </Routes>
      </main>
      <footer className="footer">
        <span>© {new Date().getFullYear()} PVPInsight</span>
        <span>Windows · Local-first · Evidence over guesses</span>
      </footer>
    </div>
  );
}
